import React, { useEffect, useState } from 'react';
import { documentTypeServices } from '../../../APIServices/documentTypeServices';
import { useToast } from '../../../hooks/useToast';

function UpdateDocumentType({
  documentTypeData,
  setConfirm,
  confirm,
  setModalOpen,
  getDocumentTypeData,
}) {
  const toast = useToast();
  const [buttonLoader, setButtonLoader] = useState(false);
  const [documentType, setDocumentType] = useState('');

  const updateDocumentTypeData = async () => {
    setButtonLoader(true);
    try {
      const data = await documentTypeServices.updateDocumentTypeData({
        documentTypeId: documentTypeData?.documentTypeId,
        documentType,
      });
      if (data?.statusCode === 200) {
        toast(data?.customMessage || 'Document type updated successfully.', 'ok');
        getDocumentTypeData();
        setConfirm(false);
        setModalOpen('');
        setDocumentType('');
      } else {
        toast(data?.customMessage || 'Unable to update document type.', 'warn');
      }
    } catch (error) {
      toast('Unable to update document type. Please try again.', 'warn');
    } finally {
      setButtonLoader(false);
    }
  };

  useEffect(() => {
    setDocumentType(documentTypeData?.documentType || '');
  }, [documentTypeData]);

  return (
    <div className="modal-backdrop" onClick={() => setModalOpen('')}>
      <div className="modal" style={{ maxWidth: 480 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <div>
            <div className="modal-title">Edit Document Type</div>
            <div className="xs muted">Update the document type details</div>
          </div>
          <button className="icon-btn" onClick={() => setModalOpen('')}>
            <i className="ti ti-x" />
          </button>
        </div>

        <div className="modal-body">
          <div className="field">
            <label className="field-label">
              Document Type Name
              <span className="req">*</span>
            </label>
            <input
              className="inp"
              autoFocus
              disabled={buttonLoader || confirm}
              placeholder="e.g., Protocol"
              value={documentType}
              onChange={(e) => setDocumentType(e.target.value)}
            />
          </div>
        </div>

        <div className="modal-foot">
          {confirm ? (
            <>
              <button className="btn btn-ghost" onClick={() => setConfirm(false)}>Cancel</button>
              <button
                className="btn btn-primary d-flex align-items-center justify-content-center gap-2"
                onClick={updateDocumentTypeData}
                disabled={buttonLoader || !documentType}
              >
                {buttonLoader ? (
                  <>
                    <div className="buttonLoader"></div>
                    <span>Updating...</span>
                  </>
                ) : (
                  <>
                    <i className="ti ti-check"></i>
                    <span>Yes, Update It!</span>
                  </>
                )}
              </button>
            </>
          ) : (
            <>
              <button className="btn btn-ghost" onClick={() => setModalOpen('')}>Cancel</button>
              <button className="btn btn-primary d-flex align-items-center justify-content-center gap-2" onClick={() => setConfirm(true)}>
                Update Document Type
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default UpdateDocumentType;
